<!-- https://systems.hispatecanalytics.com/erp/storybook-components/-/blob/develop-base/components/uitemplates/HiInfoRow.vue -->

<template>
  <div
    id="main-info-row"
    class="main-info-row"
    :class="[selectedTheme]"
    :style="customStyles"
  >
    <f7-list>
      <f7-list-item class="content-checkbox">
        <f7-badge
          v-if="titleCount && showTitleCount"
          class="margin-right-half"
        >
          {{ titleCount }}
        </f7-badge>

        <div class="item-title margin-left-half">
          {{ title }}
        </div>

        <div class="item-after">
          <slot name="after">
            {{ after }}
          </slot>
        </div>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script setup>
import { computed, onMounted, toRefs } from 'vue';

const props = defineProps({
  title: { type: String, default: '' },
  titleCount: { type: Number, default: null },
  showTitleCount: { type: Boolean, default: true },
  after: { type: [String, Number], default: '' },
  theme: { type: [String, Object], default: '' },
});

const {
  title,
  titleCount,
  showTitleCount,
  after,
  theme,
} = toRefs(props);

const selectedTheme = computed(() => {
  if (typeof theme.value === 'object') {
    return '';
  }
  return `main-info-row__${theme.value}`;
});

const customStyles = computed(() => ({
  '--custom-background': theme.value.background,
  '--custom-color': theme.value.color,
}));

onMounted(() => {
  if (typeof theme.value === 'object') {
    const element = document.getElementById('main-info-row');
    element.classList.add('theme');
  }
});
</script>

<style scoped lang="scss">
.theme {
  background-color: var(--custom-background) !important;
  color: var(--custom-color) !important;
}

.main-info-row {
  --f7-checkbox-active-color: var(--his-green);
  --bg-color: var(--his-light-blue);

  color: var(--his-oliva);
  align-items: center;
  background-color: var(--bg-color);
  border-bottom: 1px solid var(--his-light-blue);
  overflow: hidden;

  .list {
    .item-inner {
      border-bottom: none !important;
    }

    :deep(.item-inner) {
      display: flex;
      padding: 0 10px 0 0 !important;
    }

    .item-title {
      color: var(--his-oliva);
    }
  }

  .check-all-title {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: var(--his-dark-blue);
  }

  &__blue {
    --bg-color: var(--his-dark-blue);

    .list {
      .item-title {
        color: #fff;
      }
    }
  }

  &__deepgray {
    --bg-color: #484848;

    .list {
      .item-title {
        color: #fff;
      }
    }
  }

  &__yellow {
    --bg-color: var(--his-mandarina);
  }

  &__light {
    --bg-color: var(--his-tierra-white);
  }

  &__gray {
    --bg-color: var(--his-plum-haze);

    .badge {
      --f7-badge-bg-color: var(--his-dark-blue);
    }

    .list {
      .item-title {
        color: #fff;
      }
    }
  }

  &::after {
    z-index: 2;
    position: absolute;
    left: 16px;
    content: "";
    width: 0;
    height: 0;
    border-top: solid 10px var(--bg-color);
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
    filter: drop-shadow(0 1px 0 var(--his-light-blue));
  }
}
</style>
